/** Conteúdo da página de agências (agencias.v1). */

const str = (v) => String(v ?? "").trim();
const strList = (v) => (Array.isArray(v) ? v.map((x) => str(x)).filter(Boolean) : []);

const slugify = (s = "") =>
  str(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

function parseMaybe(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

function sanitizeAgency(o) {
  const src = o && typeof o === "object" ? o : {};
  const city = str(src.city);
  if (!city) return null;
  const id = str(src.id) || slugify(city) || undefined;
  return {
    id,
    city,
    state: str(src.state).toUpperCase().slice(0, 2) || undefined,
    address: str(src.address) || undefined,
    mapsUrl: str(src.mapsUrl) || undefined,
    phones: strList(src.phones),
    whatsappHrefs: strList(src.whatsappHrefs),
    hours: strList(src.hours),
  };
}

function sanitizeFaqItems(v) {
  if (!v || typeof v !== "object") return { title: "", items: [] };
  return {
    title: str(v.title) || undefined,
    items: Array.isArray(v.items)
      ? v.items
          .map((x) => ({
            question: str(x?.question),
            answer: str(x?.answer),
          }))
          .filter((x) => x.question && x.answer)
      : [],
  };
}

export function emptyAgenciasPage() {
  return sanitizeAgenciasPage({
    format: "agencias.v1",
    meta: { title: "", description: "" },
    hero: { eyebrow: "", title: "", subtitle: "", searchLabel: "", searchPlaceholder: "", ufLabel: "" },
    faq: { title: "", items: [] },
    agencies: [],
  });
}

export function sanitizeAgenciasPage(src) {
  const v = src && typeof src === "object" ? src : {};
  const metaIn = v.meta && typeof v.meta === "object" ? v.meta : {};
  const heroIn = v.hero && typeof v.hero === "object" ? v.hero : {};

  const agencies = Array.isArray(v.agencies)
    ? v.agencies.map(sanitizeAgency).filter(Boolean)
    : [];

  const faq = sanitizeFaqItems(v.faq);
  const faqOut = faq.title || faq.items.length ? faq : undefined;

  return {
    format: "agencias.v1",
    meta: {
      title: str(metaIn.title),
      description: str(metaIn.description),
    },
    hero: {
      eyebrow: str(heroIn.eyebrow) || undefined,
      title: str(heroIn.title),
      subtitle: str(heroIn.subtitle),
      searchLabel: str(heroIn.searchLabel) || undefined,
      searchPlaceholder: str(heroIn.searchPlaceholder) || undefined,
      ufLabel: str(heroIn.ufLabel) || undefined,
    },
    faq: faqOut,
    agencies,
  };
}

export function parseAgenciasPageFromContent(contentData) {
  const raw = parseMaybe(contentData?.conteudo_json);
  if (raw?.format === "agencias.v1") {
    return sanitizeAgenciasPage(raw);
  }
  return emptyAgenciasPage();
}
